<template>
  <div class="content">
    <!-- 导航条 -->
    <div class="header">
      <van-nav-bar :fixed="true" :placeholder="true" title="评价详细" />
      <div class="headerTop" @click="$router.go(-1)">
        <img src="../../assets/img/jiantou.png" alt="" />
      </div>
    </div>
    <!-- 详细内容 -->
    <div
      class="particular"
      v-for="item in particularList"
      :key="item.record_detail_id"
    >
      <div class="boxTop" @click="toShoping(item.goods_id)">
        <div class="img"><img :src="item.color_img" alt="" /></div>
        <div class="letter">
          <h3>{{ item.goods_detail_name }}</h3>
          <p>型号：{{ item.goods_name }}</p>
        </div>
      </div>
      <div class="boxBottom">
        <div class="portrait">
          <img class="headerImg" :src="item.user_head_img" alt="" />
          <div>
            <p>
              {{ item.user_name }}<span>{{ item.comment_add_time }}</span>
            </p>
            商品评分：<van-rate size=" 0.346667rem" color="#FC563A" readonly v-model="item.log_score" />
          </div>
        </div>
        <div class="detail">
          {{ item.remark }}
        </div>
        <div
          class="picture"
          v-for="pto in particularList[0].commentFileList"
          :key="pto.id"
        >
          <img :src="pto.imgUrl" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getParticular();
  },
  data() {
    return {
      recordDetailId: sessionStorage.getItem("record_detail_id"),
      particularList: [],
    };
  },
  methods: {
    async getParticular() {
      await this.$post({
        url: "oor/getRecordDetailByCommentStatus",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          status: 1,
          recordDetailId: this.recordDetailId,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.particularList = res.data; 
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转到购物车
    toShoping(id){
       sessionStorage.setItem("P_ID", id);
       this.$router.push("/toShopping");
    }
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  background-color: #f9f9f9;
  .header {
    /deep/.van-nav-bar__title.van-ellipsis {
      font-weight: 600 !important;
    }
  }
  .headerTop {
    position: fixed;
    top: 0.373333rem;
    left: 0.32rem;
    z-index: 99;
    img {
      width: 0.533333rem;
      height: 0.533333rem;
    }
  }
  .particular {
    padding: 0.426667rem 0.373333rem;
    .boxTop {
      display: flex;
      padding-bottom: 0.346667rem;
      .letter {
        margin-left: 0.266667rem;
        h3 {
          font-weight: 400;
          color: #333333;
        }
        p {
          color: #333333;
          font-size: 12px;
          font-weight: 400;
        }
      }

      .img img {
        width: 1.306667rem;
        // height: 0.933333rem;
        height: 1.226667rem;
      }
    }
    .boxBottom {
      width: 9.253333rem;
      height: auto;
      padding: 0.506667rem 0.346667rem;
      border-radius: 0.08rem;
      box-sizing: border-box;
      background-color: #ffffff;
      // border: 1px solid red;
      .portrait {
        display: flex;
        font-size: 0.32rem;
        p:first-child {
          color: #333333;
          font-weight: 400;
          font-size: 0.426667rem;
          margin-bottom: 0.2rem;
          span {
            font-size: 0.373333rem;
            margin-left: 1.5rem;
            color: #666666;
            font-weight: 400;
            font-size: 12px;
          }
        }
        .headerImg {
          margin-right: 0.293333rem;
          width: 1.333333rem;
          height: 1.333333rem;
          border-radius: 50%;
          background-color: red;
        }
      }
      .detail {
        margin-top: 0.586667rem;
        color: #333333;
      }
      .picture {
        text-align: center;
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        img {
          margin-top: 0.2rem;
          // border: 1px solid red;
          width: 8.133333rem;
          height: auto;
        }
      }
    }
  }
}
</style>
